import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spaceBetweenGutters } from 'app/spacing';
import Button from '__components/Button';
import ButtonWithDropdown from '__components/Button/WithDropdown';
import InputControl from '__components/Inputs/InputControl';
import SubNavigation from 'components/Navigation/SubNavigation';

export const StyledFormRow = styled.div<{ fullWidth?: boolean }>`
  > * {
    margin-top: 18px; // margin set to this weird value because font types caused mismatch with design, it should be 20px margin
  }

  ${({ fullWidth }) =>
    fullWidth
      ? css`
          &:first-of-type > *:first-of-type {
            margin-top: 0;
          }
        `
      : css`
          display: flex;
          justify-content: space-between;
          flex: 1;
          > div {
            width: ${spaceBetweenGutters({ columns: 2, gutter: '20px' })};
          }
          &:first-of-type > * {
            margin-top: 0;
          }
        `}
`;

export const NewTeamMemberButton = styled(ButtonWithDropdown)`
  margin: 0;
  width: auto;
  min-width: 207px;

  button:first-child {
    overflow: hidden;
    max-width: 161px;
    text-overflow: ellipsis;
  }

  .ButtonMenu__menu {
    max-width: max-content;
  }
`;

export const ExportToCSVButton = styled(Button)`
  margin: 0;
  margin-right: 15px;
`;

export const SwitchControl = styled(InputControl)`
  > label {
    margin-bottom: 22px;
    & + * {
      margin: 1px;
      label {
        // Incidentally part of <Switch />
        margin: 0;
      }
    }
  }
`;
export const StyledFormRowLast = styled(StyledFormRow)<{ checked?: boolean }>`
  > *:last-of-type {
    padding-bottom: ${({ checked }) => (checked ? 2 : 1)}px;
  }
`;

export const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;
